import { IFormErrors } from '@interfaces/IFormsErrors';
import { ICreateTask } from '@interfaces/ISales';

export interface ISalesChangesState {
  isLoading: boolean;
  success: boolean;
  getAccessToEditSuccess: boolean;
  errors: IFormErrors | null;
  newTask: {
    task: ICreateTask | null;
    loading: boolean;
    success: boolean;
  };
  files: {
    loading: boolean;
    success: boolean;
  };
  task_executer: {
    loading: boolean;
    success: boolean;
  };
  task_change_deadline: {
    loading: boolean;
    success: boolean;
  };
  task_change_status: {
    loading: boolean;
    success: boolean;
  };
  lead_contract: {
    loading: boolean;
    success: boolean;
  };
  lead_documents: {
    loading: boolean;
    success: boolean;
  };
  lead_deal: {
    loading: boolean;
    success: boolean;
    message: string[] | null;
  };
  edit_deal: {
    loading: boolean;
    success: boolean;
  };
  edit_enrollee: {
    loading: boolean;
    success: boolean;
  };
  payment_note: {
    loading: boolean;
    success: boolean;
  };
  discount_for_lead: {
    loading: boolean;
    success: boolean;
  };
  discount_for_student: {
    loading: boolean;
    success: boolean;
  };
  convert_to_lead: {
    loading: boolean;
    success: boolean;
  };
}

export const initialsSalesChangesState: ISalesChangesState = {
  isLoading: false,
  success: false,
  getAccessToEditSuccess: false,
  errors: null,
  newTask: {
    task: null,
    loading: false,
    success: false,
  },
  files: {
    loading: false,
    success: false,
  },
  task_executer: {
    loading: false,
    success: false,
  },
  task_change_deadline: {
    loading: false,
    success: false,
  },
  task_change_status: {
    loading: false,
    success: false,
  },
  lead_contract: {
    loading: false,
    success: false,
  },
  lead_documents: {
    loading: false,
    success: false,
  },
  lead_deal: {
    loading: false,
    success: false,
    message: null,
  },
  edit_deal: {
    loading: false,
    success: false,
  },
  edit_enrollee: {
    loading: false,
    success: false,
  },
  payment_note: {
    loading: false,
    success: false,
  },
  discount_for_lead: {
    loading: false,
    success: false,
  },
  discount_for_student: {
    loading: false,
    success: false,
  },
  convert_to_lead: {
    loading: false,
    success: false,
  },
};
